import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import dayjs from 'dayjs';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';

@Component({
    selector: 'app-performance-insights',
    templateUrl: './performance-insights.component.html',
    styleUrls: ['./performance-insights.component.scss'],
    standalone: false
})
export class PerformanceInsightsComponent implements OnInit {

  @Input() selectedTyre: any;
  @Input() heading: any = 'Performance';
  @Output() viewSkuLedger: EventEmitter<any> = new EventEmitter();

  selectedPeriod: number = 90;
  dateRange: any;
  branchList: any[] = [];
  isBranchVisible: boolean = false;

  periods = [
    { label: 'Last 7 Days', value: 7 },
    { label: 'Last 30 Days', value: 30 },
    { label: 'Last 90 Days', value: 90 },
    { label: 'Last 180 Days', value: 180 },
    { label: 'Last 360 Days', value: 360 }
  ];



  constructor(
    private readonly companyService: CompanyServiceService,
    private readonly storageService: StorageService,
  ) {}


  ngOnInit(): void {
    this.setPeriod(this.selectedPeriod);
    let userDetailsData = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
        this.isBranchVisible = userDetailsData?.enrollmentType === 'Company';
        if (this.isBranchVisible) {
          this.getBranchList();
        }
  }


  setPeriod(days: number) {
    this.selectedPeriod = days;
    const today = dayjs();
    const start = today.subtract(days - 1, 'day');
    const end = today;
    this.dateRange = { 
      startDate: start.format('YYYY-MM-DD'),
      endDate: end.format('YYYY-MM-DD'),
      period: days
    };
  }


  getBranchList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      let branchList = res.data || [];
      this.branchList = branchList?.filter((company: any) => company.status === 'Active') || [];
    });
  }


  clickViewSkuLedger() {
    this.viewSkuLedger.emit();
  }

}
